













import { defineComponent, computed, PropType } from "@vue/composition-api";
import Suffix from "@/components/Atoms/Typography/Suffix/index.vue";
import { formatDateForYearMonthDay } from "@/helpers/date-helper";
import { ApiResponse } from "@/api/types";

export interface Props {
  announcement: ApiResponse.Announcement;
}

export default defineComponent({
  name: "Announcement",
  components: {
    Suffix
  },
  props: {
    announcement: {
      type: Object as PropType<Props["announcement"]>,
      required: true
    }
  },
  setup(props) {
    const formattedDate = computed(() => {
      return formatDateForYearMonthDay(props.announcement.published_date);
    });

    return {
      formattedDate
    };
  }
});
